// This is a subset of the values from the Cogbase OntologyConstants.ts file
export const ENTERPRISE_CERTIFICATIONS_PROPERTY = {
  _ID: 'c9ad5976-626e-4757-b15a-d3d78250bdd6',
  CERTIFICATIONS_COMPONENT: 'dffbeb97-9d75-436d-a6de-3f10533f4921',
};

export const COMPONENT_ID_ADDRESS = 'ce3339c6-0e11-4c57-96d5-31940808dd2f';
export const COMPONENT_ID_ANNUAL_SALES = 'a7145a0a-78a2-4f74-ac75-153782ae0889';
export const COMPONENT_ID_HEADCOUNT = '6504c489-c6b5-4668-b28b-e23ad0c119f9';
export const COMPONENT_ID_NAICS_2022 = '820be483-9548-4fe6-a19a-ec7348389df8';
export const COMPONENT_ID_8_DIGIT_SIC = 'bc0ab123-3f61-47ec-9564-493e1deb8f1a';
export const COMPONENT_ID_ISIC_REV_4_CODE =
  '6a05f80a-97bc-4d6c-a5a6-212573ba749d';
